import classNames from "classnames";
import type { StyledComponentBase, SVG } from "@/components/component-base.types";
import styles from "./display-icon.module.scss";

export interface DisplayIconProps extends StyledComponentBase {
  /** Decorative SVG rendered inside the circular background. */
  icon: SVG;
}

/**
 * Renders a decorative icon in a standard circular display container.
 * Interactive semantics belong on the surrounding link or button.
 * @param iProps Display icon properties.
 * @returns A circular decorative icon.
 */
export const DisplayIcon = (iProps: DisplayIconProps) => {
  const { icon: Icon, className } = iProps;

  return (
    <span className={classNames(styles.root, className)} aria-hidden>
      <Icon />
    </span>
  );
};

export default DisplayIcon;
